import WizardContentDirective from './WizardContentDirective';
import WizardSidebarRibbonDirective from './WizardSidebarRibbonDirective';
import WizardStepProgressDirective from './WizardStepProgressDirective';
import WizardPageActionsDirective from './WizardPageActionsDirective';
import NavBarWizardBaseDirective from './NavBarWizardBaseDirective';
import WizardErrors from './components/wizard-errors';
import WizardSingleError from './components/wizard-single-error';
import 'angularRouter';
import 'gw-digitalapps-flowvalidationservice-angular';


export default angular.module('edge.platform.widgets.wizard', ['edge.platform.base', 'ui.router', 'gw-digitalapps-flowvalidationservice-angular'])
    .component('gwWizardErrors', WizardErrors)
    .component('gwWizardSingleError', WizardSingleError)
    .directive('gwWizardContent', WizardContentDirective)
    .directive('gwWizardSidebarRibbon', WizardSidebarRibbonDirective)
    .directive('gwWizardStepProgress', WizardStepProgressDirective)
    .directive('gwWizardPageActions', WizardPageActionsDirective)
    .directive('gwNavBarWizardBase', NavBarWizardBaseDirective);
